import React, { useState, useImperativeHandle, forwardRef } from 'react';

import { Button } from 'devextreme-react/button';
import Box, { Item as BoxItem } from 'devextreme-react/box';
import { LoadIndicator } from 'devextreme-react/load-indicator';
import AntLocalization from '../utils/AntLocalization';

export default forwardRef(function (props, ref) {
    const [isProcessing, setIsProcessing] = useState(false);
    const width = props.width ?? '100%';
    const actionWidth = props.actionWidth ?? 100;

    const onProceed = () => {
        setIsProcessing(false);
    };

    useImperativeHandle(ref, () => ({
        onProceed: onProceed
    }));

    return (
        <div className="ant-action-pannel" style={{ width }}>
            <Box direction="row" height="100%" width={width}>
                <BoxItem ratio={1}>
                    <span className="ant-action-text">{props.content}</span>
                    <span className="ant-action-sub-text">{props.subContent}</span>
                </BoxItem>

                <BoxItem baseSize={actionWidth + 10}>
                    <Button
                        className="ant-action-btn"
                        type="default"
                        text={props.actionText}
                        width={actionWidth}
                        stylingMode="contained"
                        onClick={() => {
                            setIsProcessing(true);
                            if (props.onClick) props.onClick(props.name);
                        }}
                    >
                        <LoadIndicator
                            className="ant-toolbar-icon-with-text ant-white-load-indicator"
                            visible={isProcessing}
                        />

                        <span className="dx-button-text">
                            {AntLocalization.translateText(props.actionText)}
                        </span>
                    </Button>
                </BoxItem>
            </Box>
        </div>
    );
});
